import { z } from 'zod';

export const regionStatusSchema = z.enum(['Active', 'Inactive', 'Terminé']);

export const regionSchema = z.object({
  id: z.string().uuid().optional(),
  name: z.string().min(1, 'Le nom est requis').max(150),
  code: z.string().min(1, 'Le code est requis').max(10, 'Le code ne doit pas dépasser 10 caractères'),
  status: regionStatusSchema.default('Active'),
  description: z.string().max(500).optional().nullable(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type Region = z.infer<typeof regionSchema>;
export type RegionStatus = z.infer<typeof regionStatusSchema>;

export const createRegionSchema = regionSchema.omit({ 
  id: true, 
  createdAt: true, 
  updatedAt: true 
});

export const updateRegionSchema = regionSchema.partial().omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
